import React, { ReactNode } from 'react'
import { useState, useEffect } from 'react';
import useRoles from "hooks/useRoles"
import useSelector from 'hooks/useSelector';
import SubHeader from "components/menu/SubHeader";

import './UserProfile.css';

import {
    Domain as RoleIcon,
    Person as ProfileIcon,
    AccountCircle as AccountIcon,
    Work as WorkIcon,
} from '@mui/icons-material';
import { Grid2 } from "@mui/material";

const RolesProfile = () => {
    const [showRoles, setShowRoles] = useState(false);

    const roleInfo = useRoles();

    useEffect(() => {

        const clearStorage = (e: KeyboardEvent) => {
            if (e.ctrlKey && e.altKey && e.key === 'u') {
                sessionStorage.clear();
                localStorage.clear();
                window.location.reload();
            }

            if (e.ctrlKey && e.altKey && e.key === 'g') {
                setShowRoles(!showRoles);
            }
        };

        document.addEventListener('keydown', clearStorage);

        return () => {
            document.removeEventListener('keydown', clearStorage);
        };

    }, [showRoles]);

    return (
        <>
            {showRoles &&
                <>
                    <div className="profile-sub-heading pt-3"><RoleIcon />User Roles</div>
                    <div className="profile-divider" />
                    {roleInfo?.roles?.map((role, i) => {
                        return (
                            <div key={i} className="profile-item">
                                <label>{role}</label>
                            </div>
                        );
                    })}
                </>
            }
        </>
    )
}

interface IProfileColProps {
    title: string,
    value: ReactNode
}

const ProfileCol = (props: IProfileColProps) => {
    return (
        <Grid2 size={{ xs: 12, md: 6 }} className="profile-item">
            <div>{props.title}:</div>
            <div>{props.value}</div>
        </Grid2>
    );
};

const ProfileDetails = () => {
    const profile = useSelector(state => state.profile);

    useEffect(() => {

    }, [profile]);

    return (
        <>
            {profile !== undefined &&
                <>
                    <div className="profile-main-heading pb-4"><ProfileIcon />My profile details</div>

                    <RolesProfile />

                    <div className="profile-sub-heading pt-3"><AccountIcon />Profile information</div>
                    <div className="profile-divider" />

                    <Grid2 container>
                        <ProfileCol title="First name" value={profile.firstname} />
                        <ProfileCol title="Last name" value={profile.lastname} />
                        <ProfileCol title="Email address" value={profile.email} />
                        <ProfileCol title="Mobile number" value={profile.mobile} />
                    </Grid2>

                    <div className="profile-sub-heading pt-3"><WorkIcon />Workplace information</div>
                    <div className="profile-divider" />

                    <Grid2 container>
                        <ProfileCol title="Title" value={profile.jobTitle} />
                        <ProfileCol title="Role" value={profile.roles[0].name} />
                        <ProfileCol title="Supervisor" value={<span>{profile.supervisorFirstname} {profile.supervisorLastname}</span>} />
                        <ProfileCol title="Supervisor email" value={profile.supervisorEmail} />
                    </Grid2>
                    <Grid2 container>
                        <ProfileCol title="City" value={profile.city} />
                        <ProfileCol title="Location" value={profile.officeLocation} />
                    </Grid2>
                    <Grid2 container>
                        <ProfileCol title="Department" value={profile.department} />
                        <ProfileCol title="Parent Department" value={profile.userDepName} />
                        <ProfileCol title="Division" value={profile.division} />
                    </Grid2>

                </>
            }
        </>
    );
}

const UserProfile = () => {
    return (
        <>
            <div className="profile-body-bg document-list">
                <div className="profile-header-bg" />
                <div className="narrow-container">
                    <SubHeader />
                    <div className="profile-container p-5">
                        <ProfileDetails />
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserProfile;
